import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import role from '../util/role'
import ReactModal from "react-modal";
import {
    TOKEN_CREATION_FEE_PAGE_LOADED,
    TOKEN_CREATION_FEE_PAGE_UNLOADED,
    TOKEN_CREATION_FEE_UPDATE,
} from '../constants/actionTypes';
import { TOKEN_STATUS, REACT_APP_DASHBOARD_URL } from '../constants/config'

const mapStateToProps = state => ({
    ...state.token,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: TOKEN_CREATION_FEE_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: TOKEN_CREATION_FEE_PAGE_UNLOADED }),
    onUpdate: (payload) => {
        dispatch({ type: TOKEN_CREATION_FEE_UPDATE, payload })
    },
});

class TokenFees extends React.Component {
    constructor() {
        super();
        this.state = {
            code: '',
            token_fee: '',
            showConfirmModal: false,
            showVerificationCodeModal: false
        }

        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
    }
    componentWillMount() {
        const payload = agent.Tokens.getTokenCreationFees()
        this.props.onLoad(payload);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.codeStatus !== nextProps.codeStatus && nextProps.codeStatus && nextProps.codeStatus === 'sent') {
            this.setState({ showConfirmModal: false, showVerificationCodeModal: true })
        }
        if (nextProps.creationFees && this.props.creationFees !== nextProps.creationFees) {
            Object.assign(this.state, {
                token_fee: nextProps.creationFees.token_fee,
            })
        }

    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleClick = () => {
        this.setState({ code: '', showConfirmModal: true });
    };
    handleConfirmSubmit = () => {
        this.setState({ showConfirmModal: false, showVerificationCodeModal: false })
        const payload = agent.Tokens.updateTokenCreationFees(this.state.token_fee, this.state.code)
        this.props.onUpdate(payload)
    }


    getParent = () => {
        return document.querySelector(".pane");
    };
    render() {
        if (!this.props.creationFees) {
            return (
                <Loading />
            )
        }

        const token_fee = this.state.token_fee;

        return (
            <div className='pane'>
                <Link className="crumb" to="/tokens">&laquo; back to tokens</Link>
                <h1>Token Creation Fee</h1>
                <ListErrors errors={this.props.errors} />

                <fieldset className="form">
                    <strong>Creation Fee (in XIF)</strong>
                    <fieldset className="form-group">
                        <input
                            type="text"
                            placeholder="5000"
                            value={token_fee}
                            onChange={this.updateState('token_fee')} />
                        
                    </fieldset>

                    <fieldset className="form-group">
                        <button className="buttonAction" onClick={() => this.handleClick()}>Update</button>
                    </fieldset>
                </fieldset>


                <ReactModal
                    isOpen={this.state.showConfirmModal}
                    className="modal"
                    parentSelector={this.getParent}
                >
                    <div id="modal-message">
                        <h1>Confirmation</h1>
                        <strong>{'Are you sure you want to update token creation fee?'}</strong>
                        <fieldset className="form form-modal">
                            <button onClick={() => this.handleConfirmSubmit()}>OK</button>
                            <button
                                className="button-sub"
                                className="button-sub"
                                onClick={() => this.setState({ showConfirmModal: false })}
                            >
                                Cancel
                            </button>
                        </fieldset>
                    </div>
                </ReactModal>
                <ReactModal
                    isOpen={this.state.showVerificationCodeModal}
                    className="modal"
                    parentSelector={this.getParent}
                >
                    <div id="modal-message">
                        <h1>Verification</h1>
                        <strong>Please enter your verification code</strong>
                        <fieldset className="form form-alpha">
                            <fieldset className="form-group">
                                <input
                                    type="text"
                                    placeholder="123456"
                                    maxLength={6}
                                    onChange={this.updateState('code')} />

                            </fieldset>
                            <fieldset className="form-group">
                                <button onClick={() => this.handleConfirmSubmit()}>Submit</button>
                                <button
                                    className="button-sub"
                                    onClick={() => this.setState({ showVerificationCodeModal: false })}>
                                    Cancel
                                </button>
                            </fieldset>
                        </fieldset>
                    </div>
                </ReactModal>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenFees);



// WEBPACK FOOTER //
// ./src/components/TokenFees.js